const style = {
  profile: {
    borderRadius: '30px',
  },
}

export default style
